// Theme: amber-circuit
// Auto-generated by scripts/materialize-theme-presets.ts
// Source of truth for theme configuration

import type { ThemePreset } from '@/lib/themes/types'

export const THEME_PRESET: ThemePreset = {
  id: 'amber-circuit',
  name: 'AMBER CIRCUIT',
  tagline: 'AMBER CIRCUIT',
  description: 'Circuito de cobre quente com brilho ambar controlado.',
  category: 'neon-cyber',
  tier: 'rare',
  basePrice: 2625,
  swatches: ['#1A1208', '#2A1E10', '#D97706', '#FEF3C7'],
  baseStyle: {
    cardClasses: '',
    shapeVars: {
      '--border-w': '1px',
      '--radius': '10px',
      '--shadow-card': '0 10px 28px rgba(0, 0, 0, 0.22)',
      '--shadow-card-active': '0 10px 28px color-mix(in srgb, var(--primary) 35%, transparent)'
    },
    shellClasses: 'font-mono theme-amber-circuit'
  },
  colorVars: {
    '--accent': '#D97706',
    '--accent-foreground': '#1A1208',
    '--background': '#1A1208',
    '--border': '#8A5A18',
    '--card': '#2A1E10',
    '--card-border-active': 'color-mix(in srgb, var(--primary) 56%, transparent)',
    '--card-completed': 'color-mix(in srgb, var(--card) 92%, var(--background) 8%)',
    '--card-foreground': '#FEF3C7',
    '--card-glow': 'color-mix(in srgb, var(--primary) 8%, transparent)',
    '--coin': 'var(--rarity-legendary)',
    '--destructive': '#ef4444',
    '--destructive-foreground': '#1A1208',
    '--foreground': '#FEF3C7',
    '--hold-fill': '#D97706',
    '--input': '#8A5A18',
    '--modal-bg': '#1A1208',
    '--modal-border': '#8A5A18',
    '--modal-overlay-bg': 'rgba(0, 0, 0, 0.75)',
    '--modal-shadow': '0 10px 28px rgba(0, 0, 0, 0.22)',
    '--muted': '#8A5A18',
    '--muted-foreground': '#FEF3C7',
    '--nav-active': '#D97706',
    '--nav-bg': '#2A1E10',
    '--popover': '#2A1E10',
    '--popover-foreground': '#FEF3C7',
    '--primary': '#D97706',
    '--primary-foreground': '#1A1208',
    '--ring': '#D97706',
    '--secondary': '#8A5A18',
    '--secondary-foreground': '#FEF3C7',
    '--streak': '#D97706',
    '--success': '#22c55e',
    '--success-foreground': '#1A1208',
    '--xp': '#D97706',
    '--xp-bg': '#2A1E10'
  },
  resolvedVars: {
    '--accent': '#D97706',
    '--accent-foreground': '#1A1208',
    '--accent-foreground-hsl': '33 53% 7%',
    '--accent-foreground-oklch': 'from #1A1208 l c h',
    '--accent-hsl': '32 95% 44%',
    '--accent-oklch': 'from #D97706 l c h',
    '--background': '#1A1208',
    '--background-hsl': '33 53% 7%',
    '--background-oklch': 'from #1A1208 l c h',
    '--border': '#8A5A18',
    '--border-hsl': '35 70% 32%',
    '--border-oklch': 'from #8A5A18 l c h',
    '--border-w': '1px',
    '--card': '#2A1E10',
    '--card-border-active': 'color-mix(in srgb, var(--primary) 56%, transparent)',
    '--card-completed': 'color-mix(in srgb, var(--card) 92%, var(--background) 8%)',
    '--card-foreground': '#FEF3C7',
    '--card-foreground-hsl': '48 96% 89%',
    '--card-foreground-oklch': 'from #FEF3C7 l c h',
    '--card-glow': 'color-mix(in srgb, var(--primary) 8%, transparent)',
    '--card-hsl': '32 45% 11%',
    '--card-oklch': 'from #2A1E10 l c h',
    '--coin': 'var(--rarity-legendary)',
    '--destructive': '#ef4444',
    '--destructive-foreground': '#1A1208',
    '--destructive-foreground-hsl': '33 53% 7%',
    '--destructive-foreground-oklch': 'from #1A1208 l c h',
    '--destructive-hsl': '0 84% 60%',
    '--destructive-oklch': 'from #ef4444 l c h',
    '--foreground': '#FEF3C7',
    '--foreground-hsl': '48 96% 89%',
    '--foreground-oklch': 'from #FEF3C7 l c h',
    '--hold-fill': '#D97706',
    '--hold-fill-hsl': '32 95% 44%',
    '--hold-fill-oklch': 'from #D97706 l c h',
    '--input': '#8A5A18',
    '--input-hsl': '35 70% 32%',
    '--input-oklch': 'from #8A5A18 l c h',
    '--modal-bg': '#1A1208',
    '--modal-bg-hsl': '33 53% 7%',
    '--modal-bg-oklch': 'from #1A1208 l c h',
    '--modal-border': '#8A5A18',
    '--modal-border-hsl': '35 70% 32%',
    '--modal-border-oklch': 'from #8A5A18 l c h',
    '--modal-overlay-bg': 'rgba(0, 0, 0, 0.75)',
    '--modal-shadow': '0 10px 28px rgba(0, 0, 0, 0.22)',
    '--muted': '#8A5A18',
    '--muted-foreground': '#FEF3C7',
    '--muted-foreground-hsl': '48 96% 89%',
    '--muted-foreground-oklch': 'from #FEF3C7 l c h',
    '--muted-hsl': '35 70% 32%',
    '--muted-oklch': 'from #8A5A18 l c h',
    '--nav-active': '#D97706',
    '--nav-active-hsl': '32 95% 44%',
    '--nav-active-oklch': 'from #D97706 l c h',
    '--nav-bg': '#2A1E10',
    '--nav-bg-hsl': '32 45% 11%',
    '--nav-bg-oklch': 'from #2A1E10 l c h',
    '--popover': '#2A1E10',
    '--popover-foreground': '#FEF3C7',
    '--popover-foreground-hsl': '48 96% 89%',
    '--popover-foreground-oklch': 'from #FEF3C7 l c h',
    '--popover-hsl': '32 45% 11%',
    '--popover-oklch': 'from #2A1E10 l c h',
    '--primary': '#D97706',
    '--primary-foreground': '#1A1208',
    '--primary-foreground-hsl': '33 53% 7%',
    '--primary-foreground-oklch': 'from #1A1208 l c h',
    '--primary-hsl': '32 95% 44%',
    '--primary-oklch': 'from #D97706 l c h',
    '--radius': '10px',
    '--ring': '#D97706',
    '--ring-hsl': '32 95% 44%',
    '--ring-oklch': 'from #D97706 l c h',
    '--secondary': '#8A5A18',
    '--secondary-foreground': '#FEF3C7',
    '--secondary-foreground-hsl': '48 96% 89%',
    '--secondary-foreground-oklch': 'from #FEF3C7 l c h',
    '--secondary-hsl': '35 70% 32%',
    '--secondary-oklch': 'from #8A5A18 l c h',
    '--shadow-card': '0 10px 28px rgba(0, 0, 0, 0.22)',
    '--shadow-card-active': '0 10px 28px color-mix(in srgb, var(--primary) 35%, transparent)',
    '--streak': '#D97706',
    '--streak-hsl': '32 95% 44%',
    '--streak-oklch': 'from #D97706 l c h',
    '--success': '#22c55e',
    '--success-foreground': '#1A1208',
    '--success-foreground-hsl': '33 53% 7%',
    '--success-foreground-oklch': 'from #1A1208 l c h',
    '--success-hsl': '142 71% 45%',
    '--success-oklch': 'from #22c55e l c h',
    '--tint-primary-subtle': 'hsla(32 95% 44% / 0.15)',
    '--xp': '#D97706',
    '--xp-bg': '#2A1E10',
    '--xp-bg-hsl': '32 45% 11%',
    '--xp-bg-oklch': 'from #2A1E10 l c h',
    '--xp-hsl': '32 95% 44%',
    '--xp-oklch': 'from #D97706 l c h'
  }
}
